import React from 'react';

import { FooterLogo } from '..';

interface LogoProps {
    about?: boolean;
}
export const FooterLogos: React.FC<LogoProps> = React.memo(({ about }) => (
    <div className='footer__logos'>
        <FooterLogo name='spektra' link={about ? '#spektra' : '/about#spektra'} />
        <FooterLogo name='prisma' link={about ? '#prisma' : '/about#prisma'} />
        <FooterLogo name='vermelion' href='https://www.vermelion.net' />
    </div>
));
